import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ProfileService } from 'src/app/services/profile.service';
import { AdminService } from 'src/app/services/admin.service';
import { AlertController, IonInput, IonModal, LoadingController, NavController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
import avatarsData from 'src/assets/images/avatars.json'
import { OverlayEventDetail } from '@ionic/core/components';
import { AuthService } from 'src/app/services/auth.service';
import { RewardCode, UserCreditsData } from 'src/app/classes/UserProfile';
import { BackendService } from 'src/app/services/backend.service';
import {
  NEWSLETTER_CONSENT_TEXT,
  NEWSLETTER_CONSENT_VERSION,
  NEWSLETTER_DETAILS,
  NEWSLETTER_REWARD_PERCENT,
} from 'src/app/config/newsletter-consent';
import { SongDraftService } from 'src/app/services/song-draft.service';
import { Browser } from '@capacitor/browser';
import { LEGAL_URLS } from 'src/app/config/legal';
import { App } from '@capacitor/app';
import { BuildInfo, getBuildInfo } from 'src/app/build-info';

type ProfileLink = {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  link: string;
};


@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  @ViewChild(IonModal) modal!: IonModal;
  /** Stand der ausgelieferten App - siehe build-info.ts. */
  buildInfo: BuildInfo = getBuildInfo();
  /** Nur nativ verfuegbar; im Browser bleibt das Feld leer. */
  appVersion = '';
  profileService = inject(ProfileService);
  adminService = inject(AdminService);
  authService = inject(AuthService);
  private backendService = inject(BackendService);
  readonly newsletterText = NEWSLETTER_CONSENT_TEXT;
  songDraftService = inject(SongDraftService);
  guestAcc: boolean = false;
  inputUserName: string = "";
  inputMail: string = "";
  inputPassword: string = "";
  avatars: string[] = avatarsData;
  selectedAvatar!: string;
  public showPassword = false;

  accountLinks: ProfileLink[] = [
    // { id: 'songs', title: 'Meine Lieder', subtitle: 'Alle generierten Songs ansehen', icon: 'musical-note-outline', link: 'song-list' },
    { id: 'profile-edit', title: 'Profil bearbeiten', subtitle: 'Profilname, Mail, Passwort', icon: 'person-outline', link: 'profile-edit' },
    // { id: 'settings', title: 'Einstellungen', subtitle: 'Passwort, Benachrichtigungen', icon: 'settings-outline', link: '' },
  ];

  supportLinks: ProfileLink[] = [
    { id: 'support', title: 'Hilfe & Support', subtitle: 'Kontakt, Rechtliches', icon: 'help-circle-outline', link: 'https://melowish.com/kontakt/' },
    { id: 'logout', title: 'Logout', subtitle: '', icon: 'exit-outline', link: 'logout' },
  ];

  @ViewChild('pwInput') pwInput!: IonInput;

  constructor(
    private alertController: AlertController,
    private navCtr: NavController,
    private loadingCtrl: LoadingController
  ) {}



  ngOnInit() {
    if(this.profileService.userProfile) {
      this.guestAcc = this.profileService.userProfile.isGuest();
      this.inputUserName = this.profileService.userProfile.displayName;
      this.inputMail = this.profileService.userProfile.email ?? "";
      this.selectedAvatar = this.profileService.userProfile.photoURL ?? "";
      console.log("slecelted",this.selectedAvatar)
    }

    // Nur nativ vorhanden - im Browser wirft der Aufruf. Bewusst nicht
    // erwartet und bewusst abgefangen: die Build-Kennung darunter steht
    // ohnehin, sie kommt aus dem Bundle.
    void App.getInfo()
      .then((info) => { this.appVersion = info.version; })
      .catch(() => { /* Browser */ });
  }

  async logoutUserPrompt() {
    const alert = await this.alertController.create({
      cssClass: "text-align-left",
      header: "Logout",
      message: "Möchstest du dich wirklich abmelden?",
      buttons: [
        {
          text: "Abbrechen",
          role: "cancel",
          cssClass: "secondary"
        },
        {
          text: "Abmelden",
          handler: async (data: any) => {
            this.logoutUser();
          },
        },
      ],
    });

    alert.present();
  }
  async logoutUser() {
    if(this.songDraftService.hasDraft()) {
      this.songDraftService.clearDraft();
    }
    await this.authService.logoutUser();
    this.navCtr.navigateRoot(["home"]);
  }

  async convertAnonAcc() {
    const loading = await this.loadingCtrl.create({
      message: 'Verifiziere Benutzeraccount...',
    });
    await loading.present();
    let errorCode = "";

    if(this.inputUserName && this.inputMail && this.inputPassword) {
      if (!this.isValidName(this.inputUserName)) {
        loading.dismiss();
        return;
      }
      errorCode = await this.profileService.convertAnonUser(this.inputUserName,this.inputMail,this.inputPassword)
    } else {
      loading.dismiss();
      ToastService.makeToast("Du musst zuerst alle Felder ausfüllen.")
      return;
    }

    loading.dismiss();
    if(!errorCode) {
      ToastService.makeToast("Dein Benutzer wurde erfolgreich verifiziert.")
      this.guestAcc = this.profileService.userProfile?.isGuest() || false;
    } else {
      if(errorCode == "auth/weak-password") {
        ToastService.makeToast("Das Passwort muss mindestens 6 Zeichen lang sein.")
      } else if(errorCode == "auth/email-already-in-use") {
        ToastService.makeToast("Die Email-Adresse wird bereits verwendet.")
      } else if(errorCode == "auth/invalid-email") {
        ToastService.makeToast("Die Email-Adresse ist ungültig.")
      } else {
        console.error("ConvertAnonAcc - Error:",errorCode)
        ToastService.makeToast("Fehler bei der Verifizierung. Probiere es später noch einmal.")
      }
      this.inputMail = "";
      this.inputPassword = "";
    }
  }

  async saveProfileData() {
    const loading = await this.loadingCtrl.create({
      message: 'Speichere Benutzerdaten...',
    });
    await loading.present();

    if(this.inputUserName) {
      if (!this.isValidName(this.inputUserName)) {
        loading.dismiss();
        return;
      }
      this.profileService.userProfile?.setDisplayName(this.inputUserName);
      await this.profileService.saveProfile();
    } else {
      loading.dismiss();
      ToastService.makeToast("Du musst zuerst alle Felder ausfüllen.")
      return;
    }

    loading.dismiss();
  }

  isValidName(n: string): boolean {
    let pattern = /^[a-zA-ZäöüßÄÖÜôÔâÂêéèÉÈÊîíìúùûý0-9 ]{1,15}$/;
    if (n.trim() === "") {
      ToastService.makeToast("Der Benutzername darf nicht leer sein.");
      return false;
    }

    if (n.length > 15) {
      ToastService.makeToast("Der Benutzername darf maximal 15 Zeichen lang sein.");
      return false;
    }

    if (!pattern.test(n)) {
      ToastService.makeToast("Der Benutzername darf nur Buchstaben, Zahlen und Leerzeichen enthalten.");
      return false;
    }

    return pattern.test(n.trim());
  }

  togglePwShow() {
    this.showPassword = !this.showPassword;
    this.pwInput.type =  this.showPassword ? 'text' : 'password';
  }

  profPicModalCancel() {
    this.modal.dismiss(null, 'cancel');
  }

  profPicModalConfirm() {
    this.modal.dismiss(this.selectedAvatar, 'confirm');
  }

  profPicModalOnWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
      if(ev.detail.data) {
        this.profileService.userProfile?.setPhotoURL(ev.detail.data);
        this.profileService.saveProfile();
        console.log("Avatar set: ", ev.detail.data);
      }
    }
  }

  avatarSelected(avatarName: string) {
    this.selectedAvatar = avatarName;
  }

  openModal() {
    if(this.guestAcc) {
      ToastService.makeToast("Du kannst ohne Verifizierung dein Profilbild nicht ändern.");
    } else {
      this.modal.present();
    }
  }


getAvailableSongCount(credits: UserCreditsData) {
  let availableCredits: string[] = [];
  if(credits.songBasic > 0) {
    availableCredits.push(`${credits.songBasic} Basic`);
  }
  if(credits.songPremium > 0) {
    availableCredits.push(`${credits.songPremium} Premium`);
  }
  if(credits.songExclusive > 0) {
    availableCredits.push(`${credits.songExclusive} Exclusive`);
  }
  return availableCredits.length > 0 ? availableCredits.join(", ") : '–'
}

  navProfileEdit() {
    this.navCtr.navigateForward("profile-edit");
  }

  topUpCredits() {
    this.navCtr.navigateForward("/song-plans")
    console.log('top up');
  }

  async openLink(link: string) {
    if(link == "logout") {
      this.logoutUserPrompt();
    } else if(link.startsWith("https://")) {
      // window.open(link, "_blank");
      await Browser.open({ url: link })
    } else {
      this.navCtr.navigateForward(link);
    }
    // npm install @capacitor-community/inappbrowser
    // npx cap sync

    // Code:

    // import { InAppBrowser } from '@capacitor-community/inappbrowser';

    // await InAppBrowser.openInWebView({
    //   url: link
    // });
  }

  /**
   * Rechtstexte liegen auf der Marketing-Seite, nicht in der App.
   *
   * Eine zweite Fassung in der App waere eine zweite Wahrheit - und die, die
   * niemand pflegt. Bis zum 30.09.2026 stand hier nur ein console.log: die
   * Links waren da, fuehrten aber nirgendwohin.
   */
  /**
   * Die offenen Rabattcodes aus Bewertungen, neueste zuerst.
   *
   * Eingeloeste fallen raus - sie waeren ein Angebot, das beim naechsten Kauf
   * abgewiesen wird. Den Vermerk setzt der Stripe-Webhook, siehe
   * markRedeemedRewardCode im Backend.
   *
   * Eine Kopie zum Sortieren - `sort()` arbeitet in place und wuerde sonst das
   * Profil im Service umstellen.
   */
  get rewardCodes(): RewardCode[] {
    const codes = this.profileService.userProfile?.rewardCodes ?? [];
    return [...codes]
      .filter((reward) => !reward.usedAt)
      .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
  }

  /**
   * Angebot, sich nachtraeglich anzumelden.
   *
   * Nur solange die Frage offen ist. Steht am Profil ein `requestedAt`, war
   * sie gestellt - und bleibt beantwortet, auch wenn sich jemand spaeter
   * wieder abmeldet. Sonst waere der Rabatt eine Drehtuer.
   */
  get showNewsletterOffer(): boolean {
    if (this.guestAcc) return false;
    return !this.profileService.userProfile?.newsletterConsent?.requestedAt;
  }

  newsletterPending = false;

  /** Die Langfassung - siehe config/newsletter-consent.ts. */
  async showNewsletterDetails(): Promise<void> {
    const alert = await this.alertController.create({
      header: NEWSLETTER_DETAILS.titel,
      message: NEWSLETTER_DETAILS.absaetze.join('\n\n'),
      cssClass: 'infoAlert',
      buttons: [
        {
          text: 'Datenschutz',
          handler: () => {
            void Browser.open({ url: NEWSLETTER_DETAILS.datenschutzUrl });
            return false;
          },
        },
        { text: 'Verstanden', role: 'cancel' },
      ],
    });
    await alert.present();
  }

  async subscribeNewsletter(): Promise<void> {
    if (this.newsletterPending) return;
    this.newsletterPending = true;

    try {
      const { requested, confirmed } =
        await this.backendService.requestNewsletterConsent(NEWSLETTER_CONSENT_VERSION);

      if (!requested) {
        ToastService.makeToast('Du hast dich dafür schon einmal entschieden.');
        return;
      }

      ToastService.makeToast(
        confirmed
          ? `Angemeldet. Dein Code über ${NEWSLETTER_REWARD_PERCENT} % steht unten.`
          : 'Fast geschafft — bestätige deine E-Mail über den Link, den wir dir geschickt haben.'
      );
    } catch (e) {
      console.error('Newsletter-Anmeldung fehlgeschlagen', e);
      ToastService.makeToast(
        'Das hat gerade nicht geklappt. Versuch es später noch einmal.'
      );
    } finally {
      this.newsletterPending = false;
    }
  }

  /**
   * Worauf ein Code gilt und woher er kommt.
   *
   * Der Anlass steht dabei, weil beide gleichzeitig im Profil liegen koennen
   * und sich sonst nur durch die Prozentzahl unterscheiden.
   */
  rewardLabel(reward: RewardCode): string {
    const reason = reward.reason === 'newsletter' ? 'Newsletter' : 'Bewertung';
    return `${reward.percent} % auf deinen nächsten Song · ${reason} · einmal einlösbar`;
  }

  /**
   * Was fuer ein Konto das ist.
   *
   * Vorher stand dort fuer jeden "Pro Member" - eine Auszeichnung, die niemand
   * erworben hatte und die fuer ein Gastkonto schlicht falsch war.
   *
   * Eine dritte Stufe fuer bestaetigte Mailadressen gaebe es erst, wenn es ein
   * Opt-in gibt, an dem sie haengen kann. Solange waere sie eine Behauptung.
   */
  get accountBadge(): string {
    if (this.guestAcc) return 'Gastkonto';
    return this.mailVerified ? 'Mitglied' : 'Nicht bestätigt';
  }

  /** Grau fuer den Gast, gelb fuer die offene Bestaetigung, sonst die Hausfarbe. */
  get accountBadgeColor(): string {
    if (this.guestAcc) return 'medium';
    return this.mailVerified ? 'primary' : 'warning';
  }

  /**
   * Ist die Adresse bestaetigt?
   *
   * Optimistisch vorbelegt, damit beim Aufbau nicht kurz "Nicht bestätigt"
   * aufblitzt, bevor die Antwort da ist.
   */
  mailVerified = true;

  /**
   * Holt den Bestaetigungsstand frisch.
   *
   * `emailVerified` am lokalen Nutzer altert: der Klick passiert in einem
   * anderen Tab oder auf einem anderen Geraet. Ohne `reload()` stuende die
   * Kennzeichnung noch stundenlang da.
   */
  private async refreshMailVerified(): Promise<void> {
    const user = this.authService.currentUser;

    if (!user || user.isAnonymous || !user.email) {
      this.mailVerified = true;
      return;
    }

    try {
      await user.reload();
    } catch {
      // Offline - dann gilt der letzte bekannte Stand.
    }

    this.mailVerified = this.authService.currentUser?.emailVerified ?? true;
  }

  ionViewWillEnter(): void {
    void this.refreshMailVerified();
  }

  copyRewardCode(code: string) {
    navigator.clipboard?.writeText(code);
    ToastService.makeToast('Code kopiert.');
  }

  openLegal(which: 'impressum' | 'datenschutz' | 'agb') {
    const url = LEGAL_URLS[which];
    if (!url) return;
    void Browser.open({ url });
  }

  trackById(_: number, item: ProfileLink) {
    return item.id;
  }

}
